<template>
	<div>
		<div class="row mb-3">
			<div class="col-lg-2">
				<label>Valor *</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="VehiculoReparacion.Valor"
				></vue-numeric>
			</div>
			<div class="col-lg-7 form-group">
				<label>Proveedores</label>	
				<treeselect
					:disabled="DisabledProveedores"
					:maxHeight="100"
					@input="get_proveedores(proveedoresId)"
					:options="ListaProveedores"
					placeholder="Busque un proveedor..."
					v-model="VehiculoReparacion.IdProveedor"
					noResultsText="Resultados no encontrados"
					noOptionsText="Opciones no disponibles"
					:disable-fuzzy-matching="true"
				/>
			</div>
			<div class="col-lg-3">
				<label for="">Número Factura o Recibo</label>
				<input type="text" class="form-control" v-model="VehiculoReparacion.NumFactura">
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-3">
				<label for="">Fecha Factura o Recibo *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoReparacion.Fecha" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-2">
				<label> Credito (días) </label>
				<!-- <input
					@input="sumDayPay()"
					class="form-control form-finanza"
					:precision="0"
					v-model="VehiculoReparacion.DiasCredito"
					placeholder="0"
				/> -->
				<select v-model="VehiculoReparacion.DiasCredito" class="form-control" @change="sumDayPay">
					<option value="0">Contado</option>
					<option value="15">15 días</option>
					<option value="30">30 días</option>
					<option value="60">60 días</option>
					<option value="90">90 días</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label for="">Fecha pago *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoReparacion.FechaPago" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-4">
				<label>Factura</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="facturareparacion" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoFactura" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoReparacion.Observaciones" cols="10" rows="3"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"reparacion",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Reparacion',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoReparacion:{
                IdVehiculoReparacion:0,
                IdVehiculo:0,
                Fecha:'',
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:'',
				ArchivoFactura:''
            },
			ArchivoFactura:'',
            errorvalidacion:[],
			ListaProveedores: [],
			IndexPaqueteCta:0,
			DisabledProveedores:false
        }
    },
	methods: {
		Guardar(){
            let Fecha='';
			let FechaPago='';
            if (this.VehiculoReparacion.Fecha!='' && this.VehiculoReparacion.Fecha!=undefined) {
                let day=this.VehiculoReparacion.Fecha.getDate();
                let month=this.VehiculoReparacion.Fecha.getMonth()+1;
                let year=this.VehiculoReparacion.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			if (this.VehiculoReparacion.FechaPago!='' && this.VehiculoReparacion.FechaPago!=undefined) {
                let day=this.VehiculoReparacion.FechaPago.getDate();
                let month=this.VehiculoReparacion.FechaPago.getMonth()+1;
                let year=this.VehiculoReparacion.FechaPago.getFullYear();
                FechaPago=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoReparacion',this.VehiculoReparacion.IdVehiculoReparacion);
            formData.set('IdVehiculo',this.VehiculoReparacion.IdVehiculo);
            formData.set('Valor',this.VehiculoReparacion.Valor);
			formData.set('NumFactura',this.VehiculoReparacion.NumFactura);
			formData.set('DiasCredito',this.VehiculoReparacion.DiasCredito);
			formData.set('IdProveedor',this.VehiculoReparacion.IdProveedor);
            formData.set('Observaciones',this.VehiculoReparacion.Observaciones);
			formData.set('ArchivoFactura',this.VehiculoReparacion.ArchivoFactura);
            formData.set('Fecha',Fecha);
			formData.set('FechaPago',FechaPago);
			let image=this.$refs.facturareparacion.files[0];
			formData.append('ArchivoFacturaFile',image);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculoreparacion/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Reparacion").modal("hide");
				this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoReparacion={
                IdVehiculoReparacion:0,
                IdVehiculo:0,
                Fecha:new Date(),
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:new Date(),
				ArchivoFactura:''
            },
			this.ArchivoFactura='Elegir archivo (0.5MB)';
			this.IndexPaqueteCta=0;
			this.DisabledProveedores=false;
        },
		Recuperar(){
            this.$http.get('vehiculoreparacion/recovery',{
                params:{
                    IdVehiculoReparacion:this.VehiculoReparacion.IdVehiculoReparacion
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculoreparacion;
                this.VehiculoReparacion.IdVehiculoReparacion=objres.IdVehiculoReparacion;
                this.VehiculoReparacion.IdVehiculo=objres.IdVehiculo;
                this.VehiculoReparacion.Valor=objres.Valor;
                this.VehiculoReparacion.Observaciones=objres.Observaciones;
				this.VehiculoReparacion.IdProveedor=objres.IdProveedor == 0 ? null : objres.IdProveedor;
				this.VehiculoReparacion.DiasCredito=objres.DiasCredito;
				this.VehiculoReparacion.NumFactura=objres.NumFactura;
				this.VehiculoReparacion.ArchivoFactura=objres.ArchivoFactura;
				this.VehiculoReparacion.Observaciones=objres.Observaciones;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoReparacion.Fecha=new Date(formatedDate);
				let formatedDate2 = objres.FechaPago.replace(/-/g, "\/");
                this.VehiculoReparacion.FechaPago=new Date(formatedDate2);
				this.ArchivoFactura=objres.ArchivoFactura;

            })
        },
		SubirArchivo(){
			const image = this.$refs.facturareparacion.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.facturareparacion;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.facturareparacion;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoFactura='Elegir archivo (0.5MB)';
                return false;
            }

            this.ArchivoFactura=image.name;
		},
		get_proveedores(id) {
			this.$http
				.get("ctaproveedores/get", {
					params: {}
				})
				.then(res => {
					this.ListaProveedores = res.data.data.proveedores.map(function(obj) {
						return { id: obj.IdProveedor, label: obj.Nombre };
					});
				});
		},
		sumDayPay() {
			let days = this.VehiculoReparacion.DiasCredito;
			let dateParam = this.VehiculoReparacion.Fecha;

			if (days > 0) {
				var date = new Date(dateParam);
				date.setDate(dateParam.getDate() + parseInt(days)); //sumamos días a la fecha recibida
				this.VehiculoReparacion.FechaPago = date; //fecha pago = fecha factura + días de crédito
			}
			else{
				this.VehiculoReparacion.FechaPago=this.VehiculoReparacion.Fecha;
			}
		},
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
			this.get_proveedores();
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoReparacion.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoReparacion.IdVehiculoReparacion = Id;
				this.Recuperar();
			}
			let User=JSON.parse(sessionStorage.getItem("user"));
			this.IndexPaqueteCta=User.listaPaquetesPrincipal.findIndex((element)=>element.Paquete=='Cuentas por Pagar / Administración' || element.Paquete=='Cuentas por Pagar / Operaciones');
			if (this.IndexPaqueteCta==-1) {
				this.DisabledProveedores=true;
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
